<ng-content></ng-content>

<app-filter-checkbox-tree
    [(models)]="countryFilters"
    (modelsChange)="filterUpdated()"
    title="Country"
    allTitle="All countries">
</app-filter-checkbox-tree>

<app-filter-checkbox-tree *ngIf="!showYearPickerCalendar"
    [(models)]="yearFilters"
    (modelsChange)="filterUpdated()"
    title="Year"
    allTitle="All Years">
</app-filter-checkbox-tree>

<app-filter-dropdown *ngIf="showYearPickerCalendar"
    [(models)]="yearFilters"
    [placeholder]="'All years of planting'"
    (modelsChange)="filterUpdated()">
</app-filter-dropdown>

<app-filter-checkbox-tree
    [(models)]="availableTreesFilters"
    (modelsChange)="filterUpdated()"
    title="Sponsor Availability"
    allTitle="All">
</app-filter-checkbox-tree>
